import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
// import { numberWithCommas, mFormatter, kmFormatter } from "../../../../../../MainContent/Dashboard/Charts/utils";
import HighchartsCustomEvents from "highcharts-custom-events";
import { numberWithCommas } from "../../../../../Dashboard/utils";
import { kmFormatter } from "../../../../../Dashboard/Charts/utils";
import moment from "moment-timezone";
HighchartsCustomEvents(Highcharts);

class CompetitorByHashtagsChart extends PureComponent {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
        this.legendAlign = this.props.isCompPage ? "right" : "center";
    }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            this.chartComponent?.current?.chart?.setSize(null, null);
            this.chartComponent?.current?.chart?.reflow();
        });
        if (this.props.widgetContainerRef?.current) {
            this.ro.observe(this.props.widgetContainerRef?.current);
        }
    }

    componentWillUnmount() {
        this.ro?.disconnect();
    }

    getChartOptions = () => {
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        const data = JSON.parse(JSON.stringify(this.props.data || {}));
        let self = this;

        let series = [
            { color: "#A070CF", name: "Like", data: data?.likes_agg ? data.likes_agg : [] },
            { color: "#53BEA7", name: "Comment", data: data?.comments_agg ? data.comments_agg : [] },
        ];

        // if (this.props.selectedCompetitorAccount?.platform === "instagram") {
        //     series.push({ color: "#2d7c1d", name: "Views", data: data?.views_agg ? data.views_agg : [] });
        // }
        if (this.props.selectedCompetitorAccount?.platform === "facebook") {
            series.push({ color: "#FBD352", name: "Share", data: data?.shares_agg ? data.shares_agg : [] });
        }

        series.push({ color: "#000", name: "Total", data: data?.total_agg ? data.total_agg : [] });

        const chartOptions = {
            chart: {
                type: this.props.graph_type === "line" ? "spline" : "column",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            title: {
                text: " ",
            },
            xAxis: {
                lineColor: "#ccd6eb",
                lineWidth: 1,
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,

                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                allowDecimals: false,
                title: {
                    text: ``,
                },
                min: data?.total_avg < data.min && self.props.showAverage ? data.min - 1 : null,
                max: data?.total_avg > data.min && self.props.showAverage ? data.max + 1 : null,
                plotLines: self.props.showAverage
                    ? [
                          {
                              color: "#8e95a4", // Color value
                              value: data?.total_avg, // Value of where the line will appear
                              width: 2, // Width of the line
                              dashStyle: "solid",
                              zIndex: 6,
                              label: {
                                  align: "right",
                                  text: `Average Engagement : ${data?.total_avg}`,
                                  x: 0,
                                  style: {
                                      color: "#8e95a4",
                                      fontWeight: "bold",
                                  },
                              },
                          },
                      ]
                    : [],
            },
            series,
            legend: {
                enabled: this.props.showLegend,
                // align: legendAlign,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },

            plotOptions: {},
            tooltip: {
                formatter: function () {
                    return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.series.name}: <b>${numberWithCommas(this.y)}</b>`;
                },

                backgroundColor: "#fff",
                borderRadius: 6,
            },
            time: {
                timezoneOffset: tzo,
            },
        };

        return chartOptions;
    };

    render() {
        if (!this.props.data) return null;

        return (
            <HighchartsReact
                highcharts={Highcharts}
                // options={this.props.graphType == "bar" ? this.getBarOptions() : this.getPieOptions()}
                options={this.getChartOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "calc(100% - 20px)" } }}
            />
        );
    }
}

export default CompetitorByHashtagsChart;
